// The view switcher identifies views by enum value, while the query string persists a human-readable token
// (?view=operational, ?view=public). Every page using the switcher needs the same pair of conversions, so the
// mapping is declared once per page as a record and the lookups are built from it here.
// The tab type is inferred from the record, not the fallback, so passing a single enum member as the fallback
// does not narrow T to that one member.
export function createViewQuery<T extends number>(queryByTab: Record<T, string>, fallback: NoInfer<T>) {
    return {
        toQuery(tab: T): string {
            return queryByTab[tab];
        },
        // Tokens are matched case-insensitively because useStateUrlParams lower-cases the query string on read.
        fromQuery(value: string | null): T {
            const match = (Object.entries(queryByTab) as Array<[string, string]>).find(([, query]) => query === value?.toLowerCase());
            return match ? (Number(match[0]) as T) : fallback;
        },
    };
}
